import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-delete\">\n  <path d=\"M9 2a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM6 7a1 1 0 011 1v11a1 1 0 001 1h8a1 1 0 001-1V8a1 1 0 112 0v11a3 3 0 01-3 3H8a3 3 0 01-3-3V8a1 1 0 011-1zm5 3a1 1 0 10-2 0v7a1 1 0 102 0v-7zm3-1a1 1 0 011 1v7a1 1 0 11-2 0v-7a1 1 0 011-1zM4 4a1 1 0 100 2h16a1 1 0 100-2H4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol